import { Component } from '@angular/core';
import { TableComponent } from "../../../shared/components/table/table.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GeneralService } from "../../../core/services/general.service";
//import { MaintenanceOrderFormComponent } from "./maintenance-order-form/maintenance-order-form.component";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import {MaintenanceOrderDetailsComponent} from "./maintenance-order-details/maintenance-order-details.component";

@Component({
    selector: 'app-maintenance-board',
    standalone: true,
    imports: [
        TableComponent
    ],
    templateUrl: './maintenance-board.component.html',
    styleUrl: './maintenance-board.component.scss'
})
export class MaintenanceBoardComponent {
    configurationTable: any = {
        "columns": [
            {
                "id": "maintenance.id",
                "title": "ID",
                "type": "text",
                "placeholder": "",
                "required": false,
                "hide": true
            },
            {
                "id": "vehicle.plates",
                "title": "Placa",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "vehicle.ns",
                "title": "N/S",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true
            },
            {
                "id": "vehicle.model",
                "title": "Modelo",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true
            },
            {
                "id": "provider.name",
                "title": "Proveedor",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "maintenance.type",
                "title": "Tipo Mtto",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true,
                "customRender": (value: any) => {
                    if (value === 'preventivo') {
                        return '<span class="badge bg-success">Preventivo</span>';
                    }
                    return '<span class="badge bg-warning text-dark">Correctivo</span>';
                }
            },
            {
                "id": "maintenance.scheduled_date",
                "title": "Fecha Programada",
                "type": "date",
                "placeholder": "",
                "required": false,
                "onlyTable": true,
                "customRender": (value: any) => {
                    if (!value) return '<span class="text-muted">-</span>';
                    return value;
                }
            },
            {
                "id": "maintenance.km",
                "title": "KM",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "maintenance.requested_by",
                "title": "Solicitante",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "maintenance.service_id",
                "title": "OS",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true,
                "customRender": (value: any) => {
                    if (!value) return '<span class="text-muted">-</span>';
                    return `OS-${value}`;
                }
            },
            {
                "id": "maintenance.total",
                "title": "Total",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true,
                "customRender": (value: any) => {
                    return `$${parseFloat(value).toLocaleString('es-MX', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                }
            },
            {
                "id": "maintenance.paid_status",
                "title": "Tipo",
                "type": "text",
                "placeholder": "",
                "required": true,
                "condition":"CASE WHEN `mo`.`paid` = 1 THEN \"Pagado\" ELSE \"Pendiente\" END",
                "onlyTable": true
            },
            {
                "id": "maintenance.created_at",
                "title": "Fecha Creación",
                "type": "datetime",
                "placeholder": "",
                "required": false,
                "onlyTable": true
            },
            {
                "btnName": "Acciones",
                "actions": [
                    {
                        "btnName": "Ver Detalles",
                        "textConfirmation": "",
                        "action": {
                            "type": "emmit",
                            "fn": this.viewDetails.bind(this)
                        },
                        "type": {
                            "type": "btn-icon",
                            "class": 'btn-pill btn-outline-primary border border-primary',
                            "icons": 'eye'
                        }
                    },
                    {
                        "btnName": "Marcar como Pagado",
                        "textConfirmation": "¿Está seguro de marcar esta orden como pagada?",
                        "action": {
                            "type": "emmit",
                            "fn": this.markAsPaid.bind(this)
                        },
                        "type": {
                            "type": "btn-icon",
                            "class": 'btn-pill btn-outline-success border border-success',
                            "icons": 'check2-circle'
                        },
                        "showCondition": (row: any) => {
                            // Solo mostrar si NO está pagado
                            return row['maintenance_orders.paid'] == 0;
                        }
                    },
                    {
                        "btnName": "Eliminar",
                        "textConfirmation": "¿Desea eliminar la orden de mantenimiento seleccionada?",
                        "action": {
                            "type": "delete"
                        }
                    }
                ]
            }
        ],
        "config": "maintenanceOrders",
        "sortColumn": "mo.created_at",
        "sortDirection": "DESC",
        "title": "Órdenes de Mantenimiento",
        "filterPrincipal": [],
        "filters": [],
        "customActions": [
            {
                "btnName": "Nueva Orden",
                "btnClass": "btn btn-primary",
                "icon": "plus-circle",
                "action": this.createNewOrder.bind(this)
            }
        ]
    };

    constructor(
        public modal: NgbModal,
        private generalService: GeneralService,
        private http: HttpClient
    ) {}

    /**
     * Ver detalles de la orden
     */
    viewDetails(row: any) {
        // const modalRef = this.modal.open(MaintenanceOrderDetailsComponent, {
        //     centered: true,
        //     size: 'xl',
        //     backdrop: 'static'
        // });
        //
        // modalRef.componentInstance.orderId = row['maintenance.id'];
    }

    /**
     * Marcar orden como pagada
     */
    markAsPaid(row: any) {
        const orderId = row['maintenance.id'];
        const headers = new HttpHeaders().set('X-Api-Key', environment.API_KEY);

        this.http.put(
            `${environment.SERVICES_URL}/maintenance/mark-as-paid`,
            { orderId: orderId },
            { headers }
        ).subscribe({
            next: (response: any) => {
                if (response.success) {
                    this.generalService.showMessage('success', 'Orden marcada como pagada exitosamente');
                    // Recargar tabla
                    window.location.reload();
                } else {
                    this.generalService.showMessage('error', response.message);
                }
            },
            error: (error) => {
                this.generalService.showMessage('error', 'Error al marcar como pagado: ' + error.message);
            }
        });
    }

    /**
     * Crear nueva orden de mantenimiento
     */
    createNewOrder() {
        // const modalRef = this.modal.open(MaintenanceOrderFormComponent, {
        //     centered: true,
        //     size: 'xl',
        //     backdrop: 'static'
        // });
        //
        // modalRef.componentInstance.confirmAction = (data: any) => {
        //     this.generalService.showMessage('success', 'Orden de mantenimiento creada exitosamente');
        //     // Recargar tabla
        //     window.location.reload();
        // };
    }
}
